<template>
  <b-card>
    <div class="section-container">
      <b-row align-v="center">
        <b-col md="12">
          <h5 class="text-uppercase text-info font-weight-bold">
            <i class="fas fa-graduation-cap mr-1"></i> Academic Details
          </h5>
        </b-col>
      </b-row>

      <!-- Loop through all unique usersubgroup_ids -->
      <b-row v-for="(subgroupId, index) in uniqueSubgroupIds" :key="index" align-v="center" class="mb-5">
        <b-col md="12">
          <!-- Academic/Internal Exam Table -->
          <div v-if="getAcademicDetailBySubgroupId(subgroupId)">
            <table class="table table-striped table-bordered mb-0">
              <thead class="thead-dark text-left">
                <tr>
                  <th colspan="100%" style="text-align: center; font-weight: bold;">
                    {{ getSubgroupDetail(subgroupId).usersubgroup_name ? getSubgroupDetail(subgroupId).usersubgroup_name
                      :
                      getSubgroupDetail(subgroupId).userSubgroupName}}
                    |
                    {{ getSubgroupDetail(subgroupId).academic_year ? getSubgroupDetail(subgroupId).academic_year :
                      getSubgroupDetail(subgroupId).academicYear }} -
                    {{ getSubgroupDetail(subgroupId).academic_semester ? getSubgroupDetail(subgroupId).academic_semester
                      :
                      getSubgroupDetail(subgroupId).academicSemester }}
                  </th>
                </tr>
                <tr>
                  <th colspan="100%" style="text-align: center; font-weight: bold;">
                    Details of Attendance, Assessment and Internal Mark
                  </th>
                </tr>
                <tr>
                  <th>Course Code</th>
                  <th>Course Name</th>
                  <th>Attendance (%)</th>
                  <th v-for="(exam, i) in getAcademicDetailBySubgroupId(subgroupId).internalExamNames" :key="i">
                    {{ exam }}
                  </th>
                  <th>Final Internal Marks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="course in getAcademicDetailBySubgroupId(subgroupId).courses" :key="course.courseId">
                  <td><b>{{ course.courseCode || null }}</b></td>
                  <td><b>{{ course.courseName || null }}</b></td>
                  <td>{{ course.generateInternalEvaluationReport ? course.attendancePercentage || null : '' }}</td>
                  <td v-for="examName in getAcademicDetailBySubgroupId(subgroupId).internalExamNames" :key="examName">
                   <span v-if="course.generateInternalEvaluationReport && getActivityMark(course.activities, examName).maxMark">
                      {{
                        isNumeric(getActivityMark(course.activities, examName).maxMark)
                          ? `${getActivityMark(course.activities, examName).mark || 0}/${getActivityMark(course.activities, examName).maxMark}`
                          : 'AB'
                      }}
                    </span>
                  </td>
                  <td>
                    <span v-if="course.generateInternalEvaluationReport && course.maxMarks">
                      {{ course.totalMarks || null }}
                      /
                      {{ course.maxMarks || null }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br><br>
          <!-- University Exam Table -->
          <div v-if="getUniversityDetailBySubgroupId(subgroupId)">
            <table class="table table-striped table-bordered mb-4">
              <thead class="thead-dark text-left">
                <tr>
                  <th colspan="100%" style="text-align: center; font-weight: bold;">
                    Details of University Exam
                  </th>
                </tr>
                <tr>
                  <th rowspan="2">Course Code</th>
                  <th rowspan="2">Course Name</th>
                </tr>
                <tr>
                  <th v-for="(exam, i) in getVisibleExamNames(subgroupId)" :key="i">
                    {{ exam.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="course in getUniversityDetailBySubgroupId(subgroupId).courses" :key="course.courseId">
                  <td><b>{{ course.courseCode || null }}</b></td>
                  <td><b>{{ course.courseName || null }}</b></td>
                  <td v-for="examName in getVisibleExamNames(subgroupId)" :key="examName">
                     {{course.universityExams.find(exam => exam.name === examName) ?
                      course.universityExams.find(exam => exam.name === examName).mark : ''}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    universityExamsDetails: Array,
    studentAcademicDetails: Array
  },
  computed: {
    uniqueSubgroupIds() {
      const universityIds = this.universityExamsDetails.map(d => d.usersubgroup_id);
      const academicIds = this.studentAcademicDetails.map(d => d.usersubgroup_id);
      return [...new Set([...universityIds, ...academicIds])];
    }
  },
  methods: {
    isNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    getVisibleExamNames(subgroupId) {
      const universityDetail = this.getUniversityDetailBySubgroupId(subgroupId);
      if (!universityDetail) return [];

      const { universityExamNames, courses } = universityDetail;

      return universityExamNames.filter(examName =>
        courses.some(course =>
          course.universityExams.find(e => e.name === examName && e.mark !== null)
        )
      );
    },
    getUniversityDetailBySubgroupId(subgroupId) {
      return this.universityExamsDetails.find(d => d.usersubgroup_id === subgroupId);
    },
    getAcademicDetailBySubgroupId(subgroupId) {
      return this.studentAcademicDetails.find(d => d.usersubgroup_id === subgroupId);
    },
    getSubgroupDetail(subgroupId) {
      return (
        this.getUniversityDetailBySubgroupId(subgroupId) ||
        this.getAcademicDetailBySubgroupId(subgroupId) ||
        {}
      );
    },
    getActivityMark(activities, name) {
      return activities.find(a => a.name === name) || {};
    }
  }
};
</script>
